import { graphql } from '~/gql'

import { useDownloadFile } from './useDownloadFile'

const document = graphql(`
  query DataSettingsPage_GenerateAnswerDownloadURL($surveyId: String!) {
    generateDownloadURL: generateAnswerDownloadURL(surveyId: $surveyId) {
      url
    }
  }
`)

export const useDownloadAnswerFile = () => useDownloadFile(document)
